
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"25","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".8","clip-path":"url(#icon-newspaper_svg__clip0_4472_8905)"}},[_c('path',{attrs:{"d":"M18.531 4.68V1.608H.856v18.828a3.462 3.462 0 003.458 3.458h15.37a3.462 3.462 0 003.458-3.459V4.681h-4.61zm-3.074 13.833H3.93v-2.305h11.527v2.305zm0-4.61H3.93v-2.306h11.527v2.306zm0-6.917v2.306H3.93V4.68h11.527v2.305zm5.38 13.449a1.154 1.154 0 01-2.306 0V6.986h2.306v13.448z","fill":"#9AA5BB"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"icon-newspaper_svg__clip0_4472_8905"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .75)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    